var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"fixed p-4 text-gray-800 bg-gray-300 border border-gray-500 rounded-md  w-52 z-11 top-6 left-6 dark:bg-gray-700 dark:text-gray-50",on:{"click":_vm.focusOnMain}},[_vm._v("\n  Skip to main content\n")])}
var staticRenderFns = []

export { render, staticRenderFns }